// Module
var code = `<!-- Non-generated report -->
<div class="empty-message" ng-if="!\$ctrl.reportGenerated">
  <span>Please select filters to generate report</span>
</div>

<div class="report" ng-if="\$ctrl.reportGenerated">

  <div class="report-description" ng-if="\$ctrl.hasData">
    <div
      class="report-description-item"
      ng-repeat="(key, value) in \$ctrl.reportContent[0].reportDescription">
      <div class="label">{{key}}</div>
      <div>: {{value}}</div>
    </div>
  </div>

  <div class="report-table-wrapper">
    <table class="table table--wide table--report"
            infinite-scroll="\$ctrl.increaseLimit()"
            infinite-scroll-distance="5"
            infinite-scroll-container="\$ctrl.container">
      <tbody ng-repeat="sheet in \$ctrl.reportContent track by \$index" style="page-break-after: {{(sheet.requiresPageBreak && \$index < \$ctrl.reportContent.length - 1) ? 'always' : 'initial'}}">
        <tr class="report-separator" ng-if="\$parent.\$index != 0" ng-repeat="_ in sheet.yoffset | foreach">
          <td ng-repeat="_ in \$ctrl.reportColumnsNum | foreach"></td>
        </tr>
        <tr class="report-separator" ng-repeat="(key, value) in sheet.sheetSubheader">
          <td colspan="4">{{key}}</td>
          <td colspan="4">{{value}}</td>
        </tr>
        <tr ng-if="sheet.sheetTitle">
          <th ng-repeat="_ in sheet.xoffset | foreach"></th>
          <th ng-repeat="header in sheet.headers track by \$index">
            <span ng-if="\$index === 0">{{sheet.sheetTitle}}</span>
          </th>
          <th ng-repeat="_ in \$ctrl.reportRightPadding(sheet) | foreach"></th>
        </tr>
        <tr>
          <th ng-repeat="_ in sheet.xoffset | foreach"></th>
          <th ng-repeat="header in sheet.headers track by \$index">{{header}}</th>
          <th ng-repeat="_ in \$ctrl.reportRightPadding(sheet) | foreach"></th>
        </tr>
        <tr ng-repeat="row in sheet.rows | limitTo: \$ctrl.lazyDisplay ? sheet.limit : sheet.rows.length track by \$index"
        >
          <td ng-repeat="_ in sheet.xoffset | foreach"></td>
          <td ng-repeat="value in row.cells track by \$index">
            <pre ng-class="{'align-right': value.alignment == 'RIGHT'}">{{\$ctrl.truncateLongReportValue && value.value.length > 120 ? (value.value | limitTo: 120) + ' .....' : value.value}}</pre>
          </td>
          <td ng-repeat="_ in \$ctrl.reportRightPadding(sheet) | foreach"></td>
        </tr>
        <tr class="report-summary" ng-repeat="row in sheet.summaryRows track by \$index">
          <td ng-repeat="_ in sheet.xoffset | foreach"></td>
          <td class="bold no-wrap" ng-repeat="value in row track by \$index"
              ng-class="{'align-right': value.alignment == 'RIGHT'}">
            {{value.value}}
          </td>
          <td ng-repeat="_ in \$ctrl.reportRightPadding(sheet) | foreach"></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/report/view/report-view.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;